import { useNavigate } from "@tanstack/react-router";

import { useCreateGrow } from "@/lib/api/grows";
import { newULID } from "@/lib/api/client";
import { ErrorState } from "@/components/error-state";

import { GrowForm, parseOptNum, type GrowFormValues } from "./form";

export function GrowNewPage() {
  const navigate = useNavigate();
  const create = useCreateGrow();

  function submit(values: GrowFormValues) {
    create.mutate(
      {
        id: newULID(),
        species: values.species,
        count: Number(values.count),
        system_type: values.system_type,
        reservoir_id: emptyToUndef(values.reservoir_id),
        water_source_id: emptyToUndef(values.water_source_id),
        feeder_class: emptyToUndef(values.feeder_class),
        ph_min: parseOptNum(values.ph_min),
        ph_ideal: parseOptNum(values.ph_ideal),
        ph_max: parseOptNum(values.ph_max),
        ec_min: parseOptNum(values.ec_min),
        ec_ideal: parseOptNum(values.ec_ideal),
        ec_max: parseOptNum(values.ec_max),
        temp_min_c: parseOptNum(values.temp_min_c),
        temp_ideal_c: parseOptNum(values.temp_ideal_c),
        temp_max_c: parseOptNum(values.temp_max_c),
        current_state: emptyToUndef(values.current_state),
        notes: values.notes ?? "",
        plant_profile_id: emptyToUndef(values.plant_profile_id),
      },
      {
        onSuccess: (created) =>
          navigate({ to: "/grows/$growId", params: { growId: created.id } }),
      },
    );
  }

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">New grow</h1>
      <GrowForm
        submitting={create.isPending}
        onSubmit={submit}
        submitLabel="Create"
        banner={
          create.error ? (
            <ErrorState
              error={create.error}
              retry={() => create.reset()}
            />
          ) : undefined
        }
      />
    </div>
  );
}

function emptyToUndef(s: string | undefined): string | undefined {
  return s && s.length > 0 ? s : undefined;
}
